module.exports = __webpack_public_path__ + "media/images/logo-fing-aced25a4601c694b0bb9423a78eb7ffa.png";